import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import axios from "axios";

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private http: HttpClient,private user:UserService) { }

  saveAs(url,name=null){
    return new Promise((resolve,reject)=>{      
      this.http.get(url,{responseType:"blob",observe:"response"})
      .subscribe(
        resp =>{
          let contentType = resp.headers.get("Content-Type");         
          let blob = new Blob([resp.body], {type: contentType});
          let fileName = name || this.getFileNameFromHeader(resp.headers.get('Content-Disposition'));
          var userAgent = window.navigator.userAgent;
          if (userAgent.match('CriOS')) 
          { //Chrome iOS                             
              var reader = new FileReader();
              reader.onloadend = function () { window.open(reader.result as string);};
              reader.readAsDataURL(blob);
          } 
          else if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) 
          { //Safari & Opera iOS                             
              var url = window.URL.createObjectURL(blob);
              window.location.href = url;
          }
          else
          {  
              FileSaver.saveAs(blob, fileName);
          }
          resolve(true);
        },
        err=>{         
          reject(false);
        }
      )
    })
  } 

  getFileNameFromHeader(contentDispositionHeader) {
    let result;
    if (contentDispositionHeader) {
        result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        result = result.replace(/"/g, '');
    }
    return result;
  }

  upload(uploadUrl,formData){    
    const options = {
        headers: {
            'Authorization':`Bearer ${this.user.getToken()}`,
            'Content-Type': 'multipart/form-data;',
            Accept: 'application/json, text/plain, */*'
        }
    };
    return axios.put(uploadUrl,formData,options);
}

}
